import EDC from '@/components/games/shared/globals';
import Slot from './letter-slot';

/**
 *
 */
EDC.Games.NameSelect.NameView = function (scene) {
  this.scene = scene;
  this.container = null;
  this.spinLeft = null;
  this.spinRight = null;
  this.spins = [];
  this.totalWidth = 0;
  return this;
};
/**
 *
 */
EDC.Games.NameSelect.NameView.prototype.create = function () {
  this.container = this.scene.add.container(0, 0);
  this.totalWidth = 0;
  this.spinLeft = this.scene.add.sprite(0, 0, 'name-selection-spin-left').setOrigin(0);
  this.spinRight = this.scene.add.sprite(0, 0, 'name-selection-spin-right').setOrigin(0);
  this.container.add([this.spinLeft, this.spinRight]);
  return this;
};
/**
 *
 */
EDC.Games.NameSelect.NameView.prototype.setName = function (firstName, lastName) {
  const name = `${firstName} ${lastName}`.toUpperCase();
  for (let i = 0; i < this.spins.length; i++) {
    this.spins[i].destroy();
  }
  this.spins = [];
  this.totalWidth = this.spinLeft.width;
  for (let i = 0; i < name.length; i++) {
    const spinSlot = new Slot(this.scene, this.container).create(this.totalWidth, 0, name[i]);
    this.totalWidth += spinSlot.getWidth();
    this.spins.push(spinSlot);
  }
  this.spinRight.x = this.totalWidth;
  this.totalWidth += this.spinRight.width;
};
/**
 *
 */
EDC.Games.NameSelect.NameView.prototype.setScale = function (scale) {
  this.container.setScale(scale);
};
/**
 *
 */
EDC.Games.NameSelect.NameView.prototype.setPosition = function (x, y) {
  this.container.setPosition(x, y);
};
/**
 *
 */
EDC.Games.NameSelect.NameView.prototype.getWidth = function () {
  return this.totalWidth;
};

export default EDC.Games.NameSelect.NameView;
